<template>
  <textarea
    :id="id"
    :name="name"
    :cols="cols"
    :rows="rows"
    :placeholder="placeholder"
    v-model="value"
    class="inquiry-form-textarea"
    @focus="event => emit('focus', event)"
    @blur="event => emit('blur', event)"
  >
  </textarea>
</template>

<script setup>
import { computed } from 'vue';
import { useField } from 'vee-validate';

const props = defineProps({
  id: { type: String, require: false },
  name: { type: String, require: true },
  cols: { type: String, require: false, default: '40' },
  rows: { type: String, require: false, default: '5' },
  placeholder: { type: String },
  validator: { type: Object, required: true },
  message: { type: String, required: true }
});
const emit = defineEmits(['focus', 'blur']);

const initialValue = computed(() => props.message);

const { value } = useField(props.name, props.validator, {
  validateOnMount: false,
  initialValue: initialValue.value
});
</script>
